var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGithubinline = function SvgGithubinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#141A1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32.106 11c-5.248-.005-10.326 1.812-14.325 5.126-3.998 3.313-6.656 7.907-7.496 12.958a21.084 21.084 0 0 0 2.91 14.603c2.72 4.376 6.949 7.665 11.929 9.278 1.112.198 1.505-.476 1.505-1.045v-3.66c-6.168 1.308-7.47-2.895-7.47-2.895a5.782 5.782 0 0 0-2.453-3.16c-1.993-1.32.162-1.32.162-1.32a4.721 4.721 0 0 1 1.95.73 4.58 4.58 0 0 1 1.426 1.49c.3.53.704.997 1.19 1.375a4.762 4.762 0 0 0 1.64.825 4.833 4.833 0 0 0 3.595-.403 4.524 4.524 0 0 1 1.356-2.881c-4.907-.542-10.059-2.392-10.059-10.574a8.21 8.21 0 0 1 2.264-5.776 7.669 7.669 0 0 1 .217-5.696s1.857-.582 6.073 2.207c3.62-.97 7.442-.97 11.062 0 4.216-2.79 6.06-2.207 6.06-2.207a7.63 7.63 0 0 1 .27 5.656 8.21 8.21 0 0 1 2.265 5.776c0 8.274-5.165 10.085-10.086 10.574a5.076 5.076 0 0 1 1.195 1.823c.26.684.365 1.415.31 2.142v5.908c0 .7.393 1.243 1.518 1.031 4.924-1.655 9.089-4.953 11.76-9.312a21.08 21.08 0 0 0 2.838-14.51c-.839-5.011-3.467-9.573-7.42-12.878-3.954-3.305-8.979-5.142-14.187-5.185",
    clipRule: "evenodd"
  })));
};
export default SvgGithubinline;